import { StyledComponentProps, ThemeContext } from "styled-components";
import { AppLogoIconDarkMode } from "./AppLogoIconDarkMode";
import { AppLogoIconLightMode } from "./AppLogoIconLightMode";
import { useContext } from "react";
import tinycolor from 'tinycolor2';

export const AppLogoIcon = (props: StyledComponentProps<"svg", any, {}, never>) => {

    const themeContext = useContext(ThemeContext)

    return (
        tinycolor(themeContext.bgColor).isDark() ? <AppLogoIconDarkMode {...props} /> : <AppLogoIconLightMode {...props} />
    );
} 